import { Injectable, inject } from '@angular/core';
import { HttpService } from '@angular-monorepo/data-access';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private HttpService = inject(HttpService);

  private readonly FORGOT_PASSWORD_URL = '/api/auth/forgot_password/';

  /**
   * Sends a password reset request to the server.
   * @param email The email address to send the reset link to.
   * @returns An Observable that emits the server response.
   */
  sendResetLink(email: string) {
    return this.HttpService.post<void, { email: string }>(this.FORGOT_PASSWORD_URL, { email });
  }

  /**
   * Sends a forgot password request to the server.
   * @param email The email address to send the forgot password link to.
   * @returns An Observable that emits the server response.
   * @deprecated Use `sendResetLink` instead.
   */
  forgotPassword(email: string) {
    return this.HttpService.post<void, { email: string }>(this.FORGOT_PASSWORD_URL, { email });
  }
}
